import React, { useState, useEffect } from 'react'
import Header from '../Component/Header';
import Sidebar from '../Component/Sidebar';
import { Button, Col, FormGroup, Row } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import baseUrl from '../Constant';
import { saveAs } from 'file-saver';


function AddFile() {
    const [img, setImage] = useState('')
    const [message, setMessage] = useState()
    const [color, setColor] = useState()
    const [viewFile, setViewFile] = useState()
    const [loading, setLoading] = useState()
    const [isOpen, setIsOpen] = useState(false)
    const params = useParams()
    const Fileuid = params.uid
    console.log(Fileuid)

    const handleFile = ((e) => {
        e.preventDefault()
        const token = JSON.parse(localStorage.getItem('token'))
        const formdata = new FormData();
        console.log(formdata)
        formdata.append('videos', img)
        formdata.append('title', 'title')
        formdata.append('case_uid', Fileuid)
        console.log(formdata)
        axios.post(`${baseUrl}/accounts/add-files`, formdata,
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    'accept': 'application/json',
                    'content-type': 'multipart/form-data',
                }
            }
        )
            .then((res) => {
                console.log(res.data)
                setMessage(res.data.message)
                getFile();
                setImage("")
                if (res.data.status === 200) {
                    setColor("green");
                    console.log('green')

                } else {
                    setColor("red")
                    console.log('red')
                }
            })
            .catch((error) => {
                console.log(error)
            })
    })
    const handleImg = ((e) => {
        console.log(e.target.files[0])
        setImage(e.target.files[0])
    })

    async function downloadImage(item) {
        try {
            const response = await fetch(item.videos);
            const blob = await response.blob();

            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);

            const fileExtension = item.videos.split('.').pop().toLowerCase();

            if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
                // Image file
                link.download = 'image_download';
            } else if (['mp4', 'webm', 'ogg'].includes(fileExtension)) {
                // Video file
                link.download = 'video_download';
            } else {
                // Unsupported file type
                console.error('Unsupported file type for download');
                return;
            }

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    }

    const getFile = (() => {
        const token = JSON.parse(localStorage.getItem('token'))
        axios.get(`${baseUrl}/accounts/view-files/${Fileuid}`, { headers: { "Authorization": `Bearer ${token}` } })
            .then((res) => {
                console.log(res.data)
                setViewFile(res.data.cases)

            })
            .catch((error) => {
                console.log(error)

            })
    })
    const handleDelete = (uid) => {
        console.log(uid)
        const token = JSON.parse(localStorage.getItem('token'))
        axios.get(`${baseUrl}/accounts/del-files/${uid}`, { headers: { "Authorization": `Bearer ${token}` } })
            .then((res) => {
                console.log(res.data)
                setMessage(res.data.message)
                if (res.data.status === 200) {
                    setColor("#008000");
                    setTimeout(() => {
                        setMessage('')
                        setColor('')
                    }, 3000)
                    getFile();
                    setIsOpen(false)
                }
                else {
                    setColor("#ff0000");
                    console.log('red')
                    setTimeout(() => {
                        setMessage('')
                        setColor("");
                    }, 2000);
                }
            })
            .catch((error) => {
                console.log(error)

            })

    }
    const handleDownload = (item) => {
        // Replace the URL with the actual path to your PDF file
        let url = `${baseUrl}/${item.videos}`;
        console.log(url)

        // Use the fetch API to get the file as a blob
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok: ${response.statusText}`);
                }
                return response.blob();
            })
            .then((blob) => {
                // Use file-saver to save the blob as a file
                saveAs(blob, "Tax-data.pdf");
            })
            .catch((error) => {
                console.error("There was an error downloading the file:", error);
            });

    }

    // Replace 'image_url.jpg' with the actual URL of your image

    useEffect(() => {
        getFile();
    }, [])

    return (
        <div>
            <Header />
            <div className='d-flex'>
                <div>
                    <Sidebar />
                </div>
                <div className='container-fluid' style={{ backgroundColor: 'rgb(42 127 155 / 24%)', height: '100vh' }}>
                    <div className='row p-3'>
                        {
                            message && <div style={{ marginBottom: 10 }}>
                                <div style={{ fontSize: 20, fontWeight: 600, color: 'white', textAlign: "center", paddingHorizontal: 20, backgroundColor: `${color}` }}>{message}</div>
                            </div>
                        }
                        <div className='col-md-12'>
                            <div className='row p-4'>
                                <div className='col-md-12'>

                                    <div className='card'>
                                        <div className='card-body'>
                                            <form onSubmit={handleFile}>
                                                <Row>
                                                    <FormGroup as={Col}>
                                                        <h3>Choose File</h3>
                                                        <div class="input-group">
                                                            <input type="file" class="form-control" id="inputGroupFile04" aria-describedby="inputGroupFileAddon04" aria-label="Upload" required onChange={handleImg} />
                                                        </div>
                                                        <div style={{ padding: '10px' }}>
                                                            <button type='submit' className='btn btn-info' style={{ color: 'white', fontWeight: '500' }}>
                                                                Upload
                                                            </button>
                                                        </div>

                                                    </FormGroup>
                                                </Row>
                                            </form>

                                        </div>

                                    </div>
                                    {
                                        viewFile?.map((item, index) => {
                                            return (
                                                < div className="card">
                                                    <div className='card-body'>
                                                        <div className='d-flex' style={{ justifyContent: "space-around", alignItems: 'center' }}>
                                                            {!item.videos.endsWith("mp4") &&
                                                                <div >
                                                                    <img src={`${baseUrl}/${item.videos}`} style={{ height: "200px", objectFit: "contain" }} />
                                                                </div>
                                                            }
                                                            {item.videos.endsWith("mp4") &&
                                                                <div >
                                                                    <video controls width="350"
                                                                        height="200">
                                                                        <source src={`${baseUrl}/${item.videos}`} type="video/mp4" />

                                                                    </video>
                                                                </div>
                                                            }
                                                            <div>
                                                                <Link to={`${baseUrl}/${item.videos}`}>
                                                                <button className='btn btn-info' style={{ color: 'white', fontWeight: '500' }} onClick={() => handleDownload(item)}>Download</button>
                                                                </Link>
                                                            </div>
                                                            <div>
                                                                <button className='btn btn-danger'
                                                                    style={{ color: "white", fontWeight: '500' }} onClick={() => setIsOpen(true)}>Delete</button>
                                                                {isOpen && (
                                                                    <div className="confirmation-modal">
                                                                        <p>Are you sure you want to delete?</p>
                                                                        <button className='btn btn-danger' onClick={() => handleDelete(item.uid)}>Yes</button>
                                                                        <button className='btn btn-success' onClick={() => setIsOpen(false)}>No</button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            )
                                        })
                                    }


                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>
        </div >
    )
}

export default AddFile;